module.exports = __webpack_public_path__ + "img/package-request.65c0d4f4.svg";